import { NavLink } from "react-router-dom";
import { Zap } from "lucide-react";
import { products } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

export function FlashSale() {
  const saleProducts = products
    .filter((p) => p.originalPrice)
    .sort((a, b) => {
      const dA = ((a.originalPrice! - a.price) / a.originalPrice!) * 100;
      const dB = ((b.originalPrice! - b.price) / b.originalPrice!) * 100;
      return dB - dA;
    })
    .slice(0, 5);

  if (saleProducts.length < 2) return null;

  const maxDiscount = Math.round(
    ((saleProducts[0].originalPrice! - saleProducts[0].price) / saleProducts[0].originalPrice!) * 100
  );

  return (
    <section className="py-10 md:py-16 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-6 md:mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-2 md:mb-3">
              <span className="relative inline-flex items-center justify-center size-4">
                <span className="absolute inline-flex size-full rounded-full bg-red-500 opacity-60 animate-ping" />
                <span className="absolute inline-flex size-2 rounded-full bg-red-600" />
                <Zap className="relative size-3.5 text-red-600 fill-red-600" />
              </span>
              <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-red-600 font-semibold animate-pulse">
                Offerte a tempo · Live
              </p>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-5xl text-stone-900 font-semibold md:font-bold tracking-tight leading-[1.05]">
              Flash Sale
            </h2>
            <p className="text-xs sm:text-sm md:text-base text-stone-500 mt-2 md:mt-3">
              Fino a <span className="text-red-600 font-semibold">−{maxDiscount}%</span> sui brand selezionati
            </p>
          </div>
          <NavLink
            to="/shop"
            className="hidden sm:inline-flex text-[10px] tracking-widest uppercase text-stone-500 hover:text-stone-900 transition-colors border-b border-stone-300 hover:border-stone-900 pb-0.5"
          >
            Tutti i saldi →
          </NavLink>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-3 md:gap-4">
          {saleProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <NavLink
            to="/shop"
            className="text-[10px] tracking-widest uppercase border border-stone-400 text-stone-600 px-8 py-3 hover:bg-stone-900 hover:text-white hover:border-stone-900 transition-colors inline-block"
          >
            Tutti i saldi
          </NavLink>
        </div>
      </div>
    </section>
  );
}
